import React from 'react'
import LogContainer from './LogContainer.js'
import PropTypes from 'prop-types'
import { Toaster } from '@CommonComponents/toast'

import { StateProvider } from '@State'

const App = props => {
  const initialState = {
    logs: [],
    selectedLog: null,
    userId: props.userId,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'selectLog':
        return {
          ...state,
          selectedLog: action.selectedLog,
        }
      case 'updateLogs':
        return {
          ...state,
          logs: action.logArray,
        }
      default:
        return state
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <LogContainer />
    </StateProvider>
  )
}

export default App

App.propTypes = {
  userId: PropTypes.string,
}
